<dx-popup
  [height]="'auto'"
  [minHeight]="600"
  [maxHeight]="650"
  [maxWidth]="1040"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="isPopupVisible"
  [title]="'COMMON.FIELDS.ATTENDEES' | translate"
  [dragEnabled]="false"
  (onHidden)="onClose()"
  (onShowing)="onShow()"
>
  <div *dxTemplate="let data of 'content'" class="modal-template">
    <dx-tabs
      class="table-tabs"
      width="100%"
      [selectedItemKeys]="[selectedTab]"
      keyExpr="id" 
      [showNavButtons]="false"
      [dataSource]="tabs"
      (onItemClick)="onTabChange($event)"
    ></dx-tabs>
    @if(selectedTab !== EmployeeStatusTabs.ByChannel) {
      <app-table
        class="persons-table"
        [data]="persons"
        [columns]="personsColumns"
        [showSearch]="true"
        [showGrouping]="true"
        [showExport]="true"
        [exportName]="'Employees list'"
        [getAdditionalRows]="getAdditionalRows"
        [mapAdditionalRow]="mapAdditionalRow"
        [searchLabel]="'COMMON.SEARCH' | translate"
        [searchPlacehoder]="'EMPLOYEE.OVERVIEW.FIND-EMPLOYEES' | translate"
        [allowDataEditing]="selectedTab == EmployeeStatusTabs.Requested ? true : false"
        (onRowUpdate)="onRequestedMemberUpdate($event)"
        (onRowUpdateStarted)="onRequestedMemberUpdateStart($event)"
        [templates]="{
          nameParticipantsTemplate: nameParticipants
        }"
      ></app-table>
      <ng-template #nameParticipants let-data>
        <ng-container *ngIf="data.data as value">
          <span>{{ value.lastName }}</span>

          @let additionalParticipants = getAdditionalPersons(value.id);

          @if (additionalParticipants.length > 0) {
            <span #tooltipTarget class="additional-participants">
              +{{ additionalParticipants.length }}
            </span>

            <dx-tooltip
              [target]="tooltipTarget"
              showEvent="mouseenter"
              hideEvent="mouseleave"
              [hideOnOutsideClick]="false"
            >
              <div *dxTemplate="let d = data; of: 'content'" class="tooltip-content">
                <div *ngFor="let participant of additionalParticipants; let i = index">
                  {{ i + 1 }}. {{ participant.lastName }}, {{ participant.firstName }}
                </div>
              </div>
            </dx-tooltip>
          }
        </ng-container>
      </ng-template>
    } @else {
      <app-table
        [data]="channels"
        [columns]="channelColumns"
        [showRowLines]="false"
        [showPageSizeSelector]="false"
        [showPagination]="false"
        [templates]="{
          nameParticipantsTemplate: nameParticipants
        }"
      ></app-table>
      <ng-template #nameParticipants let-data>
        <ng-container *ngIf="data.displayValue as display">
          <span>{{ display.value }}</span>

          @if(display.additionalParticipants?.length > 0) {
            <span #tooltipTarget class="additional-participants">
              +{{ display.additionalParticipants.length }}
            </span>

            <dx-tooltip
              [target]="tooltipTarget"
              showEvent="mouseenter"
              hideEvent="mouseleave"
              [hideOnOutsideClick]="false"
            >
              <div *dxTemplate="let d = data; of: 'content'" class="tooltip-content">
                <div *ngFor="let participant of display.additionalParticipants; let i = index">
                  {{ i + 1 }}. {{ participant.lastName }}, {{ participant.firstName }}
                </div>
              </div>
            </dx-tooltip>
          }
        </ng-container>
      </ng-template>
    }
  </div>
</dx-popup>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showModal"
  (submit)="deleteTrainingMember()"
  [options]="modalOptions"
></app-confirmation-dialog>
